/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import { debounce } from "lodash";
import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AutoForm from "../form/functional/AutoForm";
import "../grid/layout/DataGridMomSysOrderPurchase.css";
import layoutConf from "../../config/layoutConf";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import getExpirationDate from "../../lib/utils/getExpirationDate";
import failureKey from "../../lib/common/failureKey";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function EguMaterialFakeInputDetailDialog(props) {
    const {
        id,
        schema,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        title,
        fakeInputSelect,

        detailRefresh,

        ...others
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();

    const [dialogInstance, setDialogInstance] = useState();
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [eguVwFakeInputDetailOrderPurchaseOkDisabled, setEguVwFakeInputDetailOrderPurchaseOkDisabled] =
        useState(false);
    const [eguVwFakeInputDetailOrderPurchaseApi, setEguVwFakeInputDetailOrderPurchaseApi] = useState();
    const [eguVwFakeInputDetailOrderPurchaseGrid, setEguVwFakeInputDetailOrderPurchaseGrid] = useState();
    const [eguVwFakeInputDetailOrderPurchaseSelect, setEguVwFakeInputDetailOrderPurchaseSelect] = useState();

    if (schema && !schema.columnMap) {
        let columnMap = {};

        for (const column of schema.columns) {
            columnMap[column.name] = column;
        }

        schema.columnMap = columnMap;
    }

    useEffect(() => {
        (async () => {
            if (eguVwFakeInputDetailOrderPurchaseGrid) {
                eguVwFakeInputDetailOrderPurchaseGrid.selectionChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setEguVwFakeInputDetailOrderPurchaseSelect(grid.selectedItems[0]);
                        } else {
                            setEguVwFakeInputDetailOrderPurchaseSelect();
                        }
                    }, 10)
                );

                eguVwFakeInputDetailOrderPurchaseGrid.itemsSourceChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setEguVwFakeInputDetailOrderPurchaseSelect(grid.selectedItems[0]);
                        } else {
                            setEguVwFakeInputDetailOrderPurchaseSelect();
                        }
                    }, 10)
                );
            }
        })();
    }, [eguVwFakeInputDetailOrderPurchaseGrid]);

    const checkItemValidataion = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation("create", column, column.validation, formData[column.name] || "");

            if (!valid) {
                notifyWarning(msg);
                return false;
            }

            // 발주수량 대비 입고수량이 낮은경우 체크하는 코드 : 2022-12-20 미사용 처리
            // if ( parseFloat(formData.qtyFakeInput) < formData.qty ) {
            //     notifyWarning ( t ( "error.qtyLotOfNotFakeInputQty" ) );
            //     return false;
            // }
        }

        return true;
    };

    useEffect(() => {
        if (eguVwFakeInputDetailOrderPurchaseSelect) {
            setFormData((formData) => {
                let newFormData = {
                    ...formData,

                    materialFakeInputId: fakeInputSelect.materialFakeInputId,
                    orderPurchaseDetailId: eguVwFakeInputDetailOrderPurchaseSelect.orderPurchaseDetailId,

                    orderPurchaseId: eguVwFakeInputDetailOrderPurchaseSelect.orderPurchaseId,
                    orderPurchaseName: eguVwFakeInputDetailOrderPurchaseSelect.orderPurchaseName,
                    materialCode: eguVwFakeInputDetailOrderPurchaseSelect.materialCode,
                    materialCodeVer: eguVwFakeInputDetailOrderPurchaseSelect.materialCodeVer,
                    materialName: eguVwFakeInputDetailOrderPurchaseSelect.materialName,
                    materialTypeName: eguVwFakeInputDetailOrderPurchaseSelect.materialTypeName,
                    itemSpecName: eguVwFakeInputDetailOrderPurchaseSelect.itemSpecName,
                    itemUnitName: eguVwFakeInputDetailOrderPurchaseSelect.itemUnitName,

                    qty: eguVwFakeInputDetailOrderPurchaseSelect.qty,
                    unitCost: eguVwFakeInputDetailOrderPurchaseSelect.unitCost,
                    cost: eguVwFakeInputDetailOrderPurchaseSelect.cost,

                    qtyFakeInput: eguVwFakeInputDetailOrderPurchaseSelect.qty,
                    manufacturedDate: new Date(),
                    expirationDate: getExpirationDate(
                        eguVwFakeInputDetailOrderPurchaseSelect.standardExpirationDate,
                        new Date()
                    ),
                };

                return newFormData;
            });

            setEguVwFakeInputDetailOrderPurchaseOkDisabled(false);
        } else {
            setFormData({});
        }
    }, [eguVwFakeInputDetailOrderPurchaseSelect]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onNotifySuccess = (msg) => {
        notifySuccess(msg);

        if (detailRefresh) {
            detailRefresh.refresh();
        }
    };

    const onDialogInitialized = (instance) => {
        setDialogInstance(instance);

        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onApiSuccess = (result) => {
        if (eguVwFakeInputDetailOrderPurchaseApi) {
            eguVwFakeInputDetailOrderPurchaseApi.refresh();
        }
        setKeepOpen((keepOpen) => {
            if (!keepOpen) {
                dialogInstance.hide();
            }

            if (onSuccess) {
                setTimeout(() => onSuccess(result.data), 0);
            } else {
                onNotifySuccess(result.data);
            }

            return keepOpen;
        });
    };

    const onApiFailure = (reason) => {
        setEguVwFakeInputDetailOrderPurchaseOkDisabled(false);

        notifyFailure(
            t(failureKey("insert", reason.response?.status), { reason: reason.response ? reason.response.data : JSON.stringify(reason) })
        );
    };

    const onOk = (schema, formData) => {
        if (!checkItemValidataion(schema, formData)) {
            console.error("Form Validation Failed");

            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(formData, schema.validation);

            if (!valid) {
                notifyWarning(t("warning.formDataValidationFail", { msg: msg }));
                return;
            }
        }

        // build base api url

        let url;

        url = `/api/${schema.name}`;

        let apiData = { ...formData };

        let form = new FormData();

        let json = {};
        let deleted = {};

        for (const formItem in apiData) {
            if (schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file") {
                deleted[formItem] = apiData[formItem].deletedFiles;

                for (const file of apiData[formItem].activeFiles) {
                    if (file.type === "url") continue;

                    form.append(formItem, file.file);
                }
            } else {
                if (apiData[formItem] !== undefined) {
                    json[formItem] = apiData[formItem];
                }
            }
        }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        // 두 번 누름만 막는다 — 칸 검사에 걸리거나 서버가 거절하면 고쳐서 다시 누를 수 있다
        setEguVwFakeInputDetailOrderPurchaseOkDisabled(true);

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    };

    const onCancel = () => {
        setFormData();

        setEguVwFakeInputDetailOrderPurchaseSelect();

        dialogInstance.hide();
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() => setKeepOpen((keepOpen) => !keepOpen)}
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    const onChangeFormData = (formData) => {
        setFormData(formData);
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const onCloseDialog = () => {
        setFormData();

        setEguVwFakeInputDetailOrderPurchaseSelect();

        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >
            <DialogHeaderWithClose>
                <DialogTitle>{t("dialog.title.EguMaterialFakeInputDetail.create")}</DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{ padding: "0px", height: "600px" }}>
                <ReflexContainer orientation="vertical">
                    <ReflexElement flex={0.65}>
                        <BasicCrudScreenType
                            id="EguVwFakeInputDetailOrderPurchase"
                            embededInOtherScreenType
                            view="EguVwFakeInputDetailOrderPurchase"
                            headerTitle={t("term.poDetail")}
                            noExcel
                            onInitialized={(grid) => {
                                grid.selectionMode = "Row";
                                setEguVwFakeInputDetailOrderPurchaseGrid(grid);
                            }}
                            onApiInitialized={(api) => {
                                setEguVwFakeInputDetailOrderPurchaseApi(api);
                            }}
                            onModifyViewUrl={(url) => `${url}/${fakeInputSelect.orderPurchaseId}`}
                        />
                    </ReflexElement>

                    <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                    <ReflexElement flex={0.35}>
                        <div
                            style={{
                                padding: "16px",
                            }}
                        >
                            <AutoForm
                                id="material-fake-input-create-form"
                                schema={schema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChangeFormData}
                                modifyFormDataCallback={(formData, name) => {
                                    if (name === "manufacturedDate") {
                                        formData.expirationDate = getExpirationDate(
                                            eguVwFakeInputDetailOrderPurchaseSelect?.standardExpirationDate,
                                            new Date(formData.manufacturedDate)
                                        );
                                    }
                                }}
                            />
                        </div>
                    </ReflexElement>
                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert onClose={onCloseNotification} variant="filled" severity={notification.severity}>
                        {notification.msg}
                    </Alert>
                </Snackbar>
            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[t("common.add")]}
                buttonDisabled={[eguVwFakeInputDetailOrderPurchaseOkDisabled, false]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />
        </Dialog>
    );
}

export default EguMaterialFakeInputDetailDialog;
